export const getNextDictionaryIndex = (dictionary: any) => {
  const indices = Object.keys(dictionary ?? {}).map((index) => parseInt(index));

  return Math.max(-1, ...indices) + 1;
};
